import ThreeButton from '../MaleShirts/ThreeButton'
import Hawaiian from '../MaleShirts/Hawaiian'
import Stripped from '../MaleShirts/Stripped'
import TShirt from '../MaleShirts/TShirt'
import Baseball from '../MaleShirts/Baseball'
import Hoodie from '../MaleShirts/Hoodie'
import SuitBlack from '../MaleShirts/SuitBlack'
import TieDye from '../MaleShirts/TieDye'
import BowTie from '../MaleShirts/BowTie'
import JeanJacket from '../MaleShirts/JeanJacket'
import TieOveralls from '../MaleShirts/TieOveralls'
import BowTieOveralls from '../MaleShirts/BowTieOveralls'
import Jersey from '../MaleShirts/Jersey'
import VNeck from '../MaleShirts/VNeck'
import Cardigan from '../MaleShirts/Cardigan'
import Lumberjack from '../MaleShirts/Lumberjack'
import VarsityJacket from '../MaleShirts/VarsityJacket'
import CollarPlain from '../MaleShirts/CollarPlain'
import Overalls from '../MaleShirts/Overalls'
import CollaredColored from '../MaleShirts/CollaredColored'
import Plaid from '../MaleShirts/Plaid'
import GolfShirt from '../MaleShirts/GolfShirt'

const defaultY = 126

const data = [
  {
    id: 'TShirt',
    svg: TShirt,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'ThreeButton',
    svg: ThreeButton,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hawaiian',
    svg: Hawaiian,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Stripped',
    svg: Stripped,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Baseball',
    svg: Baseball,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hoodie',
    svg: Hoodie,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'SuitBlack',
    svg: SuitBlack,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'TieDye',
    svg: TieDye,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'BowTie',
    svg: BowTie,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'JeanJacket',
    svg: JeanJacket,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'TieOveralls',
    svg: TieOveralls,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'BowTieOveralls',
    svg: BowTieOveralls,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Jersey',
    svg: Jersey,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'VNeck',
    svg: VNeck,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Cardigan',
    svg: Cardigan,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Lumberjack',
    svg: Lumberjack,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'VarsityJacket',
    svg: VarsityJacket,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'CollarPlain',
    svg: CollarPlain,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Overalls',
    svg: Overalls,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'CollaredColored',
    svg: CollaredColored,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Plaid',
    svg: Plaid,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'GolfShirt',
    svg: GolfShirt,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
]

export default data
